/* Lustruva · confirmation visuelle d'ajout au panier (aucune donnée inventée) */
(function () {
  var toast;
  function show(msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lus-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span></span>';
    toast.querySelector('span').textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  }
  var origFetch = window.fetch;
  if (!origFetch) return;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r && r.ok) show('Ajouté au panier'); }).catch(function () {});
    }
    return p;
  };
})();
